import { render, staticRenderFns } from "./purchasing.vue?vue&type=template&id=8acea20a"
import script from "./purchasing.vue?vue&type=script&lang=js"
export * from "./purchasing.vue?vue&type=script&lang=js"
import style0 from "./purchasing.vue?vue&type=style&index=0&id=8acea20a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports